import { Sheet } from "react-modal-sheet";
import styled from "styled-components";
import { useState } from "react";

export const CustomSheet = styled(Sheet)`
  .react-modal-sheet-backdrop {
    /* custom styles */
  }
  .react-modal-sheet-container {
    @media (min-width: 360px) {
      height: calc(100% - 120px) !important;
    }

    @media (min-width: 375px) {
      height: calc(100% - 50px) !important;
    }

    @media (min-width: 390px) {
      height: calc(100% - 220px) !important;
    }

    @media (min-width: 412px) {
      height: calc(100% - 300px) !important;
    }
  }
  .react-modal-sheet-header {
    /* custom styles */
  }
  .react-modal-sheet-drag-indicator {
    /* custom styles */
  }
  .react-modal-sheet-content {
    /* custom styles */
  }
`;
